<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar :pageName="'Careers'"></navbar>
			<!--导航-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img class="bg" src="../../assets/img_h5/蒙版组 7@2x.webp" />
				<div class="msg_box">
					<div class="tit">CorDx Careers</div>
					<div class="txt">
						Now Seeking: Innovative People
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="txt">
					At CorDx, we’re driven by innovation. With nearly two decades of IVD experience, we’re a leader in IVD research and development, manufacturing, supply, and distribution. If you have a similar drive, a career at CorDx may be right for you. There’s no better place to begin—and continue—your career than right here.
				</div>
				<div class="txt">
					When you join the CorDx team, you’ll be at the forefront of an innovative global diagnostics model that rewards dedication, creativity, and science-focused solutions.
				</div>
				<div class="txt">
					We’re transforming global diagnostics. Have what it takes to join us? Browse our career opportunities to begin.
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_3_el" style="background-color: #F9FAFE;">
					<img class="bg" src="../../assets/img_h5/careers_1.webp" />
					<div class="tit">
						Comprehensive Health Care
					</div>
					<div class="txt">
						CorDx’s competitive benefits package includes medical, dental, and vision coverage for employees and their dependents.
					</div>
				</div>
				<div class="block_3_el" style="background-color: #FEFBF3;">
					<img class="bg" src="../../assets/img_h5/careers_2.webp" />
					<div class="tit">
						Retirement Plans
					</div>
					<div class="txt">
						Your future is important to us. That’s why we sponsor generous retirement plans that are sure to set your mind at ease.
					</div>
				</div>
				<div class="block_3_el" style="background-color: #FBFEFC;">
					<img class="bg" src="../../assets/img_h5/careers_3.webp" />
					<div class="tit">
						Professional Development
					</div>
					<div class="txt">
						CorDx is growing fast—and we want you to grow, too. We encourage and provide support for our team members as they pursue new skills and improve existing ones.
					</div>
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div class="block_4">
				<!--条件筛选-->
				<div class="cate_box"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit">Categories</div>
					<div class="list_box">
						<div v-for="(value, index) in cateOptions" :key="index" class="list_el" @click="cateHandle(value);">
							<div class="list_el_main">
								<div class="left">
									<img :src="value.is_checked == 1 ? require('@/assets/img_h5/checked.png') : require('@/assets/img_h5/no_check.png') " />
								</div>
								<div class="right">
									{{ value.catname }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="cate_box"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit">Location</div>
					<div class="list_box">
						<div v-for="(value, index) in locationOptions" :key="index" class="list_el" @click="locationHandle(value);">
							<div class="list_el_main">
								<div class="left">
									<img :src="value.is_checked == 1 ? require('@/assets/img_h5/checked.png') : require('@/assets/img_h5/no_check.png') " />
								</div>
								<div class="right">
									{{ value.catname }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<!--条件筛选-->
				<!--搜索区域-->
				<div class="input_box"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<input v-model="searchVal" placeholder="Search for a job..." v-on:input="searchInput" />
					<!-- <div class="btn_box" @click="searchClick">
						<van-icon name="search" size="20px" color="#ffffff" style="position: relative;top: 3px;font-weight: bold;" />
					</div> -->
				</div>
				<!--搜索区域-->
				<div
					v-if="careersData.length > 0"
					v-loading="careersLoading"
					class="product_list"
				>
					<el-collapse v-for="(value, index) in careersData" accordion>
						<van-collapse v-model="activeNames" :border="false" @change="collChange">
							<van-collapse-item :name="value.id" :border="false">
								<template #title>
									<div class="title_box">
										<div class="tips_box">
											<div v-for="(value1, index1) in value.address_list" :key="index1" class="tips_el">{{ value1.catname }}</div>
										</div>
										<div class="tit">{{ value.title }}</div>
									</div>
								</template>
								<template #right-icon>
									<van-icon :name="isHas(value.id) ? 'clear' : 'add' " size="24px" color="#0B318F" />
								</template>
								<div class="content">
									<div class="content_main" v-html="value.content"></div>
									<div class="btn_box_ty btn_box" @click="goApply(value)">
										Apply Now<img src="../../assets/img_h5/组 32@2x.png" />
									</div>
								</div>
							</van-collapse-item>
						</van-collapse>
					</el-collapse>
				</div>
				<div v-else style="padding: 20px 0;color: #999999;text-align: center;" class="search_box">
					<img src="../../assets/img_h5/search_no.png" />
				</div>
				<div v-if="careersData.length > 0" class="page_box">
					<el-pagination
						layout="prev, pager, next"
						:total="careersPage"
						:page-size="5"
						@current-change="careersPageChange"
					></el-pagination>
				</div>
			</div>
			<!--块4-->
			<!--块6-->
			<div class="block_6"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_6_el" style="background-color: #F9FAFE;" @click="goCulture(1)">
					<img class="bg" src="../../assets/img/2023102701.webp" />
					<div class="tit">Aiiso Truth Code</div>
				</div>
				<div class="block_6_el" style="background-color: #FBFEFC;" @click="goCulture(3)">
					<img class="bg" src="../../assets/img/2023102703.webp" />
					<div class="tit">Aiiso Work Code</div>
				</div>
				<div class="block_6_el" style="background-color: #FEFBF3;" @click="goCulture(4)">
					<img class="bg" src="../../assets/img/20251021.webp" />
					<div class="tit">Aiiso Social Art</div>
				</div>
			</div>
			<!--块6-->
			<!--块5-->
			<div class="block_5"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="title">Recent News</div>
				<div class="news_box">
					<div class="icon_left animate__animated animate__fadeInLeft" @click="bannerLeftClick">
						<van-icon name="arrow-left" color="#ffffff" size="21px" />
					</div>
					<div class="icon_right animate__animated animate__fadeInRight" @click="bannerRightClick">
						<van-icon name="arrow" color="#ffffff" size="21px" />
					</div>
					<van-swipe class="my-swipe" :show-indicators="true" :loop="true" :autoplay="3000" indicator-color="#0B318F" ref="swipeDom2" :stop-propagation="false">
						<van-swipe-item v-for="(value, index) in newsData" :key="index">
							<div class="swiper_el" @click="goResourcesInfo(value)">
								<img class="bg" :src="value.image" />
								<div class="txt_box">
									<div class="tit">{{ value.title }}</div>
									<div class="time">{{ value.fabu_time }}</div>
								</div>
							</div>
						</van-swipe-item>
					</van-swipe>
				</div>
				<div class="btn_box_f">
					<div class="btn_box_ty btn_box" @click="goResources">
						View More<img src="../../assets/img_h5/组 32@2x.png" />
					</div>
				</div>
			</div>
			<!--块5-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/nav.vue'  //导航组件
import footerBox from '@/component/footer.vue'  //版权组件
import fixed from '@/component/fixed.vue'  //联系我们悬浮
import { resourcesList, careersCate, careersLocation, careersList } from '@/api/public_h5';
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			newsData: JSON.parse(sessionStorage.getItem('newsData')),
			isShow: null,
			cateOptions: [],
			locationOptions: [],
			searchVal: '',
			activeNames: [],
			nowActived: [],
			cateIds: [],
			locationsIds: [],
			careersData: [],
			careersPage: 0,
			noPage: 1,
			careersLoading: false,
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		//请求岗位列表
		that.getCareersCate();
		//请求岗位地点
		that.getCareersLocation();
		//请求岗位列表
		that.getCareersList();
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//跳转文化规章
		goCulture(value) {
			let that = this;
			switch(value) {
				case 1:
					that.$router.push({ path: '/Culture/Aiiso_Truth_Code' });
				break;
				case 2:
					that.$router.push({ path: '/culture/cn' });
				break;
				case 3:
					that.$router.push({ path: '/Culture/Aiiso_Work_Code' });
				break;
				case 4:
					that.$router.push({ path: '/Culture/Aiiso_Social_Art' });
				break;
			}
		},
		//点击进去新闻详情
		goResourcesInfo(value) {
			let that = this;
			//that.$router.push({ path: '/resources-info', query: { id: value.unionid, } });
			that.$router.push({ name: 'Resourcesinfo', params: { resourcesInfoId: value.custom, } });
		},
		bannerLeftClick(value) {  //导航左侧按钮点击
			let that = this;
			that.$refs.swipeDom2.prev();
		},
		bannerRightClick(value) {  //导航右侧按钮点击
			let that = this;
			that.$refs.swipeDom2.next();
		},
		//岗位输入搜索
		searchInput() {
			let that = this;
			that.noPage = 1;
			that.getCareersList();
		},
		//点击搜索岗位
		searchClick() {
			let that = this;
			that.noPage = 1;
			that.getCareersList();
		},
		//请求岗位分类
		getCareersCate() {
			let that = this;
			careersCate({
				language: sessionStorage.getItem('lang'),
			}).then(res => {
				that.cateOptions = res.data;
			});
		},
		//请求岗位地点
		getCareersLocation() {
			let that = this;
			careersLocation({
				language: sessionStorage.getItem('lang'),
			}).then(res => {
				that.locationOptions = res.data;
			});
		},
		//岗位分类点击
		cateHandle(val) {
			let that = this;
			let dataArray = that.cateOptions;
			that.cateIds = [];
			dataArray.forEach((value, index) => {
				if(value.id == val.id) {
					if(value.is_checked == 0) {
						dataArray[index].is_checked = 1;
					}else {
						dataArray[index].is_checked = 0;
					}
				}
			});
			that.cateOptions = dataArray;
			that.cateOptions.forEach((value, index) => {
				if(value.is_checked == 1) {
					that.cateIds.push(value.id);
				}
			});
			that.noPage = 1;
			that.getCareersList();
		},
		//折叠面板点击
		collChange(activeNames) {
			let that = this;
			that.nowActived = activeNames;
		},
		//地点分类点击
		locationHandle(val) {
			let that = this;
			let dataArray = that.locationOptions;
			that.locationsIds = [];
			dataArray.forEach((value, index) => {
				if(value.id == val.id) {
					if(value.is_checked == 0) {
						dataArray[index].is_checked = 1;
					}else {
						dataArray[index].is_checked = 0;
					}
				}
			});
			that.locationOptions = dataArray;
			that.locationOptions.forEach((value, index) => {
				if(value.is_checked == 1) {
					that.locationsIds.push(value.id);
				}
			});
			that.noPage = 1;
			that.getCareersList();
		},
		//岗位列表分页
		careersPageChange(val) {
			let that = this;
			that.noPage = val;
			that.getCareersList();
		},
		//请求岗位列表
		getCareersList() {
			let that = this;
			that.careersLoading = true;
			careersList({
				cate_id: that.cateIds.join(','),
				address_id: that.locationsIds.join(','),
				page: that.noPage,
				keyword: that.searchVal,
				page_size: 5,
				language: sessionStorage.getItem('lang'),
			}).then(res => {
				that.careersData = res.data.data;
				that.careersPage = res.data.total;
				that.careersLoading = false;
			});
		},
		isHas(id) {
			let that = this;
			if(that.nowActived.length > 0) {
				let str = null;
				that.nowActived.forEach((value, index) => {
					if(value == id) {
						str = 1;
					}
				});
				if(str == 1) {
					return true;
				}else {
					return false;
				}
			}else {
				return false;
			}
		},
		goResources() {
			this.$router.push({ path: '/resources' });
		},
		goApply(value) {
			sessionStorage.setItem('careersName', value.title);
			this.$router.push({ path: '/careers-apply', });
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	/*块6*/
	.block_6{
		padding: 0px 20px 50px 20px;
		.block_6_el{
			margin-top: 36px;
			padding-bottom: 10px;
			.txt{
				padding: 0 20px 20px 20px;
				font-size: 20px;
				color: #706B69;
			}
			.tit{
				position: relative;
				padding: 20px 20px 16px 20px;
				font-size: 24px;
				img{
					width: 21px;
					position: absolute;
					right: 0;
				}
			}
			img.bg{
				width: 100%;
			}
		}
		.title{
			padding-bottom: 64px;
			font-size: 36px;
		}
	}
	/*块5*/
	.block_5{
		padding: 42px 20px 120px 20px;
		background-image: linear-gradient(180deg, #F1ECE6 20%, #FFFFFF 100%);
		.btn_box{
			margin: 42px 0 0 0;
		}
		.news_box{
			.swiper_el{
				padding-bottom: 25px;
				background-color: #FFFFFF;
				//box-shadow: 0 0 8px rgb(200, 200, 200, 0.2);
				.txt_box{
					padding: 20px;
					.time{
						padding-top: 30px;
						font-size: 18px;
						color: #706B69;
					}
					.tit{
						font-size: 22px;
					}
				}
				img.bg{
					width: 100%;
					height: auto;
					object-fit: cover;
				}
			}
		}
		.title{
			padding-bottom: 24px;
			font-size: 42px;
		}
	}
	/*块4*/
	.block_4{
		padding: 0 20px;
		.page_box{
			padding: 30px 0;
			text-align: center;
		}
		.input_box{
			padding: 42px 0;
			.btn_box{
				margin-left: 3%;
				padding: 5px 12px;
				border-radius: 18px;
				background-color: #0066D4;
				display: inline-block;
				cursor: pointer;
			}
			input{
				width: 100%;
				height: 50px;
				line-height: 50px;
				border: 1px solid #EFEFEF;
				background-color: #ffffff;
				text-indent: 20px;
				font-size: 16px;
				color: #0B318F;
			}
			input:focus{
				outline: none;
				border: 2px solid #0066D4;
			}
		}
		.cate_box{
			padding: 20px;
			background-color: #EFEFEF;
			.list_box{
				.list_el{
					padding: 10px 0;
					.list_el_main{
						font-size: 18px;
						cursor: pointer;
						display: flex;
						.right{
							flex: 1;
							padding-left: 8px;
							line-height: 1.2;
						}
						.left{
							width: 18px;
							img{
								width: 100%;
							}
						}
					}
				}
			}
			.tit{
				padding-bottom: 15px;
				font-size: 21px;
				font-weight: bold;
			}
		}
	}
	/*块3*/
	.block_3{
		padding: 0px 20px 50px 20px;
		.block_3_el{
			margin-top: 36px;
			padding-bottom: 34px;
			.txt{
				padding: 0 20px 20px 20px;
				font-size: 20px;
				color: #706B69;
			}
			.tit{
				position: relative;
				padding: 36px 20px 16px 20px;
				font-size: 24px;
				img{
					width: 21px;
					position: absolute;
					right: 0;
				}
			}
			img.bg{
				width: 100%;
			}
		}
		.title{
			padding-bottom: 64px;
			font-size: 36px;
		}
	}
	/*块2*/
	.block_2{
		padding: 75px 20px 42px 20px;
		.txt{
			padding-bottom: 34px;
			font-size: 18px;
		}
	}
	/*块1*/
	.block_1{
		position: relative;
		.msg_box{
			position: absolute;
			width: 100%;
			top: 50%;
			z-index: 1;
			transform: translate(0%,-50%);
			color: #000000;
			text-align: center;
			.txt{
				font-size: 20px;
			}
			.tit{
				font-size: 50px;
			}
		}
		img.bg{
			width: 100%;
		}
	}
}
</style>

<style scoped>
>>> .product_list ol,>>> .product_list ul{
	list-style: initial !important;
	margin: revert !important;
	padding: revert !important;
}
/* >>> .product_list h3 strong{
	font-size: 24px;
}
>>> .product_list h3 font{
	font-size: 24px;
}
>>> .product_list h5{
	font-size: 20px;
}
>>> .product_list h5 font{
	font-size: 20px;
}
>>> .product_list p{
	font-size: 18px;
}
>>> .product_list p font{
	font-size: 18px;
}
>>> .product_list li{
	font-size: 18px;
}
>>> .product_list li::before{
	content: '●';
	padding-right: 4px;
} */
>>> .product_list .van-collapse-item__content{
	color: #000000 !important;
	font-size: 16px !important;
	padding: 30px 0 42px 0;
	border-bottom: 1px solid #999999;
}
>>> .product_list .van-cell{
	padding: 30px 0 20px 0;
	font-size: 18px;
	color: #000000;
	border-bottom: 1px solid #999999;
}
>>> .product_list .el-collapse{
	border: none;
}
>>> .product_list .van-icon{
	top: 30px;
}
.product_list .content_main{
	padding-bottom: 30px;
}
>>> .product_list .title_box{
	cursor: pointer;
}
>>> .product_list .title_box .tit{
	padding-top: 18px;
	font-size: 25px;
}
>>> .product_list .title_box:hover{
	color: #0066D4;
}
>>> .product_list .title_box .tips_box .tips_el{
	display: inline-block;
	margin-right: 20px;
	margin-bottom: 20px;
	padding: 8px 30px;
	border-radius: 20px;
	background-color: #EFEFEF;
	color: #0B318F;
	font-size: 18px;
}
</style>
